// extracted by mini-css-extract-plugin
export default {"footer":"AppFooter_footer__OoPcd","content":"AppFooter_content__2vwAd","spin":"AppFooter_spin__oE9VO"};